import React, { ComponentPropsWithoutRef, FC, useEffect, useRef } from 'react';

// Styles
import './total-range-item.scss';

type TTotalRangeItemProps = ComponentPropsWithoutRef<'div'> & {
  data: [total: number, value: number],
  colors?: string[],
  width?: number,
  height?: number,
};

export const TotalRangeItem: FC<TTotalRangeItemProps> = (
  { data, colors = ['#f2f3f4', '#EAB30B'], width = 130, height = 130, children }: TTotalRangeItemProps
) => {

  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if(!canvas) return;

    const ctx = canvas.getContext('2d');
    if(!ctx) return;

    // Calculating the total amount of data for calculating interest
    const total = data[0];

    // Circle radius and hole radius for donut chart
    const radius = Math.min(width, height) / 2;
    const innerRadius = radius * 0.7;

    let startAngle = 0;

    // Clear the canvas before drawing a new graph
    ctx.clearRect(0, 0, width, height);

    data.forEach((value, index) => {
      // Calculate the start angle and end angle for a sector
      const endAngle = startAngle + (Math.PI * 2 * (value / total));

      // Set a color for the sector
      ctx.fillStyle = colors[index];

      // Draw a sector
      ctx.beginPath();
      ctx.moveTo(width / 2, height / 2);
      ctx.arc(width / 2, height / 2, radius, startAngle, endAngle);
      ctx.lineTo(
        width / 2 + innerRadius * Math.cos(endAngle),
        height / 2 + innerRadius * Math.sin(endAngle)
      );
      ctx.arc(width / 2, height / 2, innerRadius, endAngle, startAngle, true);
      ctx.closePath();
      ctx.fill();

      // Update the start angle for the next sector
      startAngle = endAngle;
    });
  }, [data, colors, width, height]);

  return (
    <div className="total-range-item">
      <canvas className="total-range-item--canvas" ref={ canvasRef } width={ width } height={ height } />
      <div className="total-range-item--text">
        { children }
      </div>
    </div>
  );
}
